import { makeStyles } from '@material-ui/core';

export default makeStyles({
  textField: {
    margin: 0,
  },
});
